import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

const SearchIcon = (props: IconWrapperProps) => (
  <IconWrapper viewBox="0 0 24 24" title="Search" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.207 17c4.136 0 7.5-3.364 7.5-7.5S14.343 2 10.207 2s-7.5 3.364-7.5 7.5 3.364 7.5 7.5 7.5ZM11.817.133c3.98.658 7.169 3.9 7.777 7.887a9.474 9.474 0 0 1-2.005 7.448l6.118 6.118A.999.999 0 1 1 22.293 23l-6.118-6.118a9.474 9.474 0 0 1-7.448 2.005C4.737 18.28 1.497 15.09.84 11.11-.232 4.62 5.327-.939 11.817.133Z"
      clipRule="evenodd"
    />
  </IconWrapper>
);

export default SearchIcon;
